<template>
<div>
    
	<div class="account with-sidebar ">
		
		
		
		<main >


            <div class="container">
                <div class="row justify-content-md-center">
                    <div class="box_general col-5 ">

                        <div class="header_box">
                            <h2><i class="pe-7s-id"></i>Cambiar contraseña</h2>
                        </div>
                        
                        <div class="row ">
                            <div class="col-lg-12">
                                <div class="form-group mb-0">
                                    <label>Contraseña actual</label>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <div class="input-float-button" @click="showPassword=!showPassword">
                                        <i class="" :class="showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
                                    </div>
                                    <input  
                                        :type="showPassword ? 'text' : 'password'"
                                        class="form-control" 
                                        placeholder="Contraseña actual" 
                                        v-model="me.password" 
                                        :class="{'is-invalid':validationErrors['general']}"
                                        >
                                    <div class="invalid-feedback">{{validationErrors['general']}}</div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group mb-0">
                                    <label>Contraseña nueva</label>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <div class="input-float-button" @click="showPassword=!showPassword">
                                        <i class="" :class="showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
                                    </div>
                                    <input  
                                        :type="showPassword ? 'text' : 'password'"
                                        class="form-control" 
                                        placeholder="Contraseña nueva" 
                                        v-model="me.passwordNew" 
                                        :class="{'is-invalid':validationErrors['data.passwordNew']}"
                                        >
                                    <password 
                                        v-model="me.passwordNew"
                                        @score="passwordScore"
                                        :strength-meter-only="true"
                                    />
                                    <div class="invalid-feedback">{{validationErrors['data.passwordNew']}}</div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group mb-0">
                                    <label>Confirmar contraseña</label>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <div class="input-float-button" @click="showPassword=!showPassword">
                                        <i class="" :class="showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
                                    </div>
                                    <input  
                                        :type="showPassword ? 'text' : 'password'"
                                        class="form-control" 
                                        placeholder="Confirmar contraseña" 
                                        v-model="me.passwordNewConfirm" 
                                        :class="{'is-invalid':validationErrors['data.passwordNewConfirm']}"
                                        >
                                    <div class="invalid-feedback">{{validationErrors['data.passwordNewConfirm']}}</div>
                                </div>
                            </div>
                            
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col">
                                <button class="btn btn-sm pull-right" :class="hasChanges ? 'btn-success' : 'btn-light'" @click="saveChanges">Cambiar contraseña</button>
                                <router-link tag="button" class="btn btn-sm pull-left" to="/settings">Volver</router-link>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

		</main>

	</div>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'


import Password from 'vue-password-strength-meter'

export default {
    name: 'PasswordChange',
    metaInfo: {
		title: 'Cambiar contraseña',
	},
    components: {
        Password
    },
    data() {
        return {
            me:{},
            hasChanges:false,
            loading:false,
            validationErrors:{},
            passwordStrength:0,
            showPassword:false,
        }
    },
    computed: {
		...mapGetters(['isAuthenticated','loggedMedic'])
	},
    methods:{
        passwordScore (score) {
            this.passwordStrength = score;
        },
        saveChanges(){
            var error=false;
            this.validationErrors = {};
            
            if( this.passwordStrength <3 ){
                error=true;
                this.validationErrors['data.passwordNew'] = 'La contraseña nueva es muy debil';
            }
            if( this.me.passwordNew != this.me.passwordNewConfirm  ){
                error=true;
                this.validationErrors['data.passwordNewConfirm'] = 'Las contraseñas no coinciden';
            }

            if( !this.loading && !error){
                this.loading=true;
                var dataInput = {
                    password: this.me.password,
                    passwordNew: this.me.passwordNew,
                    passwordNewConfirm: this.me.passwordNewConfirm,
                };
                console.log('dataInput',dataInput);
                
                this.$apollo.mutate({
                    mutation: gql`mutation ( $data:UpdateMedicPasswordInput! ){
                        updateMedicPassword( data: $data) {
                            id
                        }
                    }`,
                    variables: {
                        data: dataInput,
                    }
                })
                .then((data) => {
                    this.$toast.success('Cambios guardados');
                    console.log('save control then ',data);
                    this.loading=false;
                    this.hasChanges = false;
                    this.me = {};
                })
                .catch(error => {
                    this.$toast.error('Oops!');
                    
                    let { graphQLErrors } = error;
                    if (graphQLErrors[0].extensions.category === "validation") {
                        this.validationErrors = this.parseErrors(graphQLErrors[0].extensions.validation);
                    }else{
                        this.validationErrors['general'] = graphQLErrors[0].debugMessage;
                    }
                    this.loading=false;
                })
            }
        },
        parseErrors(errors){
            let parsedErrors = [];
            Object.keys(errors).forEach( (key) => {
                parsedErrors[key] = errors[key][0];
                
            });
            return parsedErrors;
        },
    },
    beforeRouteLeave (to, from , next) {
        if(this.hasChanges ){
            const answer = window.confirm('¿De verdad quieres irte? Usted tiene cambios sin guardar!')
            if (answer) {
                next()
            } else {
                next(false)
            }
        }else{
            next()
        }
    }
    
}
</script>

<style scoped>

</style>
